import { BaseModel } from './BaseModel';

export default class Item extends BaseModel {
  defaults() {
    return {
      id: '',
      name: '',
      price: 0,
      status: 'active',
      short_description: '',
      import_key: null,
      description: '',
      taxable: 0,
      temperature: 'cold',
      availability_start: null,
      availability_end: null,
      brand_id: null,
      photo_id: '',
      photo: {},
      itemAttributes: [],
      dietaryRestrictionIds: [],
      attributeIds: [],
      menuItems: [],
    };
  }

  options() {
    return {
      identifier: 'id',
    };
  }

  routes() {
    const include = ['attributes', 'brand', 'dietaryRestrictions', 'photo'];
    return {
      fetch: `/items/{id}?with=${include.join(',')}`,
      save: `/items/{id}?with=${include.join(',')}`,
      create: `/items`,
    };
  }

  onFetchSuccess(response) {
    const data = response.getData();

    if (!data || !data.success) {
      throw this.createResponseError('Invalid item');
    }

    // attributes is a reserved keyword for this plugin
    data.data.itemAttributes = data.data.attributes;
    delete data.data.attributes;

    this.assign(data.data);
    this.set(this, 'fatal', false);
    this.set(this, 'loading', false);
    this.emit('fetch', {
      error: null,
    });
  }
}
